
export interface CampaignType {
  value: string;
  label: string;
}

export const cashbackTypes: CampaignType[] = [
  { value: "accumulated_spending", label: "Gasto Acumulado" },
  { value: "first_purchase", label: "Primeira Compra" },
  { value: "birthday_campaign", label: "Campanha de Aniversário" },
];

export const referralTypes: CampaignType[] = [
  { value: "bonus_referral", label: "Bônus para Indicador" },
  { value: "more_discount", label: "Mais Desconto para Indicado" },
  { value: "double_bonus", label: "Bônus Duplo" },
];

export interface ValueFieldConfig {
  show: boolean;
  label: string;
  placeholder: string;
  inputType: string;
  prefix?: string;
  helperText?: string;
}

export interface AdvancedFieldsConfig {
  showMinimumSpent: boolean;
  showCashbackTemplate: boolean;
  showDelayDays: boolean;
  showMaxCoupons: boolean;
}

export const getValueFieldConfig = (campaignType: string): ValueFieldConfig => {
  switch (campaignType) {
    case "accumulated_spending":
      return {
        show: true,
        label: "Valor Mínimo Gasto",
        placeholder: "200",
        inputType: "number",
        prefix: "R$",
        helperText: "Valor mínimo que o cliente deve gastar para ganhar o cashback"
      };
    case "first_purchase":
      return {
        show: true,
        label: "Porcentagem de Desconto (%)",
        placeholder: "10",
        inputType: "number",
        prefix: "%",
        helperText: "Porcentagem de desconto que será aplicada na primeira compra (1-100%)"
      };
    case "birthday_campaign":
      return {
        show: false,
        label: "",
        placeholder: "",
        inputType: "number"
      };
    case "bonus_referral":
      return {
        show: true,
        label: "Valor do Bônus",
        placeholder: "50",
        inputType: "number",
        prefix: "R$",
        helperText: "Valor do bônus que o indicador irá receber"
      };
    case "more_discount":
      return {
        show: true,
        label: "Porcentagem de Desconto",
        placeholder: "15",
        inputType: "number",
        prefix: "%",
        helperText: "Porcentagem de desconto para o indicado"
      };
    case "double_bonus":
      return {
        show: true,
        label: "Multiplicador",
        placeholder: "2",
        inputType: "number",
        prefix: "x",
        helperText: "Multiplicador do bônus normal"
      };
    default:
      return {
        show: false,
        label: "",
        placeholder: "",
        inputType: "number"
      };
  }
};

export const getAdvancedFieldsConfig = (campaignType: string): AdvancedFieldsConfig => {
  // Para campanhas de primeira compra, não mostrar template de cashback
  if (campaignType === 'first_purchase') {
    return {
      showMinimumSpent: true,
      showCashbackTemplate: false,
      showDelayDays: true,
      showMaxCoupons: true
    };
  }
  
  // Para outros tipos, mostrar todos os campos avançados
  return {
    showMinimumSpent: true,
    showCashbackTemplate: true,
    showDelayDays: true,
    showMaxCoupons: true
  };
};
